import "./style.css"

const SkeletonBase = ({
    variant = 'text',
    width = '100%',
    height = '1em',
    className = '',
    style,
    }) => {

    const skeletonClasses = `Skeleton Skeleton-${variant} ${className}`;

    return (
        <div
            className={skeletonClasses}
            style={{
                width,  
                height,
                ...style,
            }}
        />
    );
};

export default SkeletonBase